<figure class="highcharts-figure">
<div id="container"></div>
</figure>